import React from 'react';

const MascotFoldedArms = ({ text }) => {
  return (
    <div style={{ position: 'relative', width: '300px' }}>
      {/* Your image with a speech bubble */}
      <img
        src="/mascot_folded_arms.png"
        alt="Mascot"
        style={{ width: '100%' }}
      />

      {/* Speech text overlay - tweak position to match your bubble */}
      <div
        style={{
          position: 'absolute',
          top: '15px',
          left: '115px',
          width: '180px',
          height: '95px',
          whiteSpace: 'pre-line', // ← this is the key
          backgroundColor: 'transparent',
          borderRadius: '8px',
          padding: '6px 10px',
          fontSize: '12.5px',
          fontFamily: "'Work Sans'",
          fontWeight: 400,
          
          textAlign: 'center'
        }}
      >
        {text}
      </div>
    </div>
  );
};

export default MascotFoldedArms;
